import BookingApi from "@/services/api/BookingApi"
import TrackingService from "@soenergy/frontend-library/src/services/TrackingService"

export const untestedActions = {
  async fetchBookingData({ commit, rootState }) {
    commit("SET_BOOKING_API_STATUS", "LOADING")

    try {
      const bookings = await BookingApi.getBookings(rootState.customerId)
      TrackingService.sendEvent("bookingDetailsFetchedSuccessfully")
      commit("SET_BOOKING_DATA", bookings)
      commit("SET_BOOKING_API_STATUS", "SUCCESS")
    } catch (error) {
      commit("SET_BOOKING_API_STATUS", "ERROR")
      throw error
    }
  },
}

export const untestedMutations = {
  SET_BOOKING_DATA(state, bookingData) {
    state.bookings = bookingData
  },
  SET_BOOKING_API_STATUS(state, status) {
    state.bookingApiStatus = status
  },
}

export const untestedGetters = {
  latestBooking(state) {
    const filteredBookings = state.bookings.filter(
      (booking) => booking.createdDate
    )
    if (!filteredBookings.length) return []
    return filteredBookings.reduce((latestBooking, currentBooking) => {
      return currentBooking.createdDate.isAfter(latestBooking.createdDate)
        ? currentBooking
        : latestBooking
    })
  },
  activeBookings(state) {
    return (state.bookings ?? []).filter((booking) => booking.isActive)
  },
  hasBookings(_state, getters) {
    return getters.activeBookings.length > 0
  },
}
